import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ErrorContent } from './components';
import { VITE_MOCK_ENABLED } from './config';
import { GlobalProvider } from './providers';
import './index.scss';
import './lib/datadog';

// https://github.com/mswjs/msw/issues/1657#issuecomment-2041708994
const initializeMocks = async () => {
  if (VITE_MOCK_ENABLED === 'true') {
    const { worker } = await import('./mocks/browser');
    worker.start({ onUnhandledRequest: 'bypass' }).catch((e) => {
      throw e;
    });
  }
};
initializeMocks();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <GlobalProvider errorFallback={<ErrorContent height="100vh" />}>
    <App />
  </GlobalProvider>,
);
